export const NAV_PROGRESS_START = "fd-nav-start";
export const NAV_PROGRESS_DONE = "fd-nav-done";

export function startNavProgress() {
    if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") {
        return;
    }
    window.dispatchEvent(new Event(NAV_PROGRESS_START));
}

export function appRouteKey(href, base = "http://local.invalid") {
    try {
        const next = new URL(href, base);
        return `${next.pathname}?${next.search.replace(/^\?/, "")}`;
    } catch {
        return href;
    }
}

export function didAppRouteChange(beforeHref, afterHref, base) {
    return appRouteKey(beforeHref, base) !== appRouteKey(afterHref, base);
}

export function wrapHistoryForNavProgress(history, location, onRouteChange) {
    const origPush = history.pushState.bind(history);
    const origReplace = history.replaceState.bind(history);

    const wrap = (orig) =>
        function (data, unused, url) {
            const before = location.href;
            const result = orig(data, unused, url);
            if (didAppRouteChange(before, location.href)) {
                onRouteChange();
            }
            return result;
        };

    history.pushState = wrap(origPush);
    history.replaceState = wrap(origReplace);

    return () => {
        history.pushState = origPush;
        history.replaceState = origReplace;
    };
}

export function doneNavProgress() {
    if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") {
        return;
    }
    window.dispatchEvent(new Event(NAV_PROGRESS_DONE));
}

export function shouldTrackAnchorClick(event, anchor) {
    if (event.defaultPrevented) return false;
    if (event.button != null && event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (anchor.hasAttribute("download")) return false;
    const target = anchor.getAttribute("target");
    if (target && target !== "" && target !== "_self") return false;

    const href = anchor.getAttribute("href");
    if (!href || href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:")) {
        return false;
    }
    if (href.toLowerCase().startsWith("javascript:")) return false;

    let next;
    try {
        next = new URL(href, window.location.origin);
    } catch {
        return false;
    }
    if (next.origin !== window.location.origin) return false;
    if (next.pathname === window.location.pathname && next.search === window.location.search) {
        return false;
    }
    return true;
}
